import React from 'react';

const MacroBar = ({ label, value, goal, color }) => {
  const pct = Math.min((value / goal) * 100, 100);
  return (
    <div>
      <div className="flex justify-between text-sm mb-1.5">
        <span className="font-medium text-emerald-950">{label}</span>
        <span className="text-emerald-950/60">{Math.round(value)}g / {goal}g</span>
      </div>
      <div className="h-2 bg-emerald-950/5 rounded-full overflow-hidden">
        <div className="h-full rounded-full transition-all duration-700" style={{ width: `${pct}%`, background: color }} />
      </div>
    </div>
  );
};

export default MacroBar;
